import styled, { css } from 'styled-components';

import theme from 'styles/theme';

interface SpinWrapperProps {
  spinning: boolean;
  size: 'small' | 'default' | 'large';
  tip?: string;
  delay?: number;
  fullscreen?: boolean;
  hasIcon: boolean;
  centerHorizontally?: boolean;
  centerVertically?: boolean;
}

const tipModifier = (tip: string) => css`
  &::after {
    content: attr(data-tip);
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${theme.COLORS.PRIMARY};
    font-size: 12px;
    opacity: 0.8;
  }
`;

const fullscreenModifier = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.COLORS.BACKGROUND_PRIMARY};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
`;

const centerHorizontallyModifier = css`
  margin-left: auto;
  margin-right: auto;
`;

const centerVerticallyModifier = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const SpinWrapper = styled.div<SpinWrapperProps>`
  ${({ spinning, tip, fullscreen, centerHorizontally, centerVertically }) => css`
    display: inline-block;
    ${tip && tipModifier(tip)}
    ${fullscreen && fullscreenModifier}
    ${centerHorizontally && centerHorizontallyModifier}
    ${centerVertically && centerVerticallyModifier}
  `}
`;
